import React, { useState, useEffect } from 'react';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import { showToast } from 'stores/ToastStore';
import CargomaticSelect from 'components/v2/select';
import { withTranslation } from 'react-i18next';

export const ROUTERS = {
  GOOGLE_MILES: { name: 'Google Miles', value: 'Google Miles' },
  PC_MILER: { name: 'PC Miler', value: 'PC Miler' },
  RAND_MC_NALLY: { name: 'Rand McNally', value: 'Rand McNally' },
};

const ROUTE_TYPES = [
  ROUTERS.GOOGLE_MILES,
  ROUTERS.PC_MILER,
  ROUTERS.RAND_MC_NALLY,
];

const [oldestVersion, latestVerion] = [18, 36];

const PC_MILER_VERSIONS = [...Array(latestVerion - oldestVersion + 1)].map(
  (_, index) => ({
    name: `${ROUTERS.PC_MILER.value} ${index + oldestVersion}`,
    value: `${ROUTERS.PC_MILER.value} ${index + oldestVersion}`,
  }),
);

const ROUTING_CONFIGURATIONS = [
  ...PC_MILER_VERSIONS,
  { name: 'Current', value: 'Current' },
];

function RoutingConfiguration(props) {
  const { t } = props;
  const [routing_type, handleRoutingType] = useState({
    ...ROUTERS.GOOGLE_MILES,
    default: true,
  });
  const [routing_configuration, handleConfiguration] = useState({
    name: 'Current',
    value: 'Current',
    default: true,
  });

  useEffect(() => {
    async function updateRoutingConfiguration() {
      const { shipper } = props;
      if (
        (routing_type.default && routing_configuration.default) ||
        !routing_type.value ||
        !routing_configuration.value
      )
        return;

      try {
        const response = await UserWebAPIUtils.updateRoutingConfiguration(
          shipper._id,
          {
            routing_type: routing_type.value,
            routing_configuration: routing_configuration.value,
          },
        );
        if (response.success === true) {
          showToast('Success', t('ROUTING_CONFIG_UPDATE_SUCCESS'), 'success');
        } else {
          showToast('Error', t('ROUTING_CONFIG_UPDATE_FAILURE'), 'error');
        }
      } catch (err) {
        console.log('Problem updating routing config ', err);
        showToast(
          'Error',
          t('ROUTING_CONFIG_UPDATE_FAILURE_ERR', { err }),
          'error',
        );
      }
    }
    updateRoutingConfiguration();
  }, [routing_type, routing_configuration]);

  useEffect(() => {
    async function retrieveRoutingConfiguration() {
      const { shipper } = props;
      try {
        const config = await UserWebAPIUtils.retrieveRoutingConfiguration(
          shipper._id,
        );
        if (config && config.routingConfiguration) {
          const { routing_type, routing_configuration } =
            config.routingConfiguration;
          if (routing_type && routing_configuration) {
            handleRoutingType({
              name: routing_type,
              value: routing_type,
              default: true,
            });
            handleConfiguration({
              name: routing_configuration,
              value: routing_configuration,
              default: true,
            });
          }
        }
      } catch (err) {
        console.log('Problem getting routing config ', err);
      }
    }
    retrieveRoutingConfiguration();
  }, []);

  return (
    <div style={{ height: 100 }}>
      <div className="m-6 w-2/4">
        <div className="flex justify-between -mx-2">
          <CargomaticSelect
            className="w-48 ml-2 mr-8"
            label={t('ROUTING_TYPE')}
            info={t('ROUTING_TYPE_TIP')}
            caption={t('SELECT_ROUTING_TYPE')}
            items={ROUTE_TYPES}
            showCaption
            value={routing_type.value}
            valueKey="value"
            textKey="value"
            onSelect={handleRoutingType}
          />
          <CargomaticSelect
            className="w-48"
            label={t('ROUTING_CONFIGURATION')}
            info={t('ROUTING_CONFIGURATION_TIP')}
            caption={t('SELECT_ROUTING_CONFIG')}
            items={ROUTING_CONFIGURATIONS}
            disabled={
              !routing_type || routing_type.value !== ROUTERS.PC_MILER.value
            }
            showCaption
            value={routing_configuration.value}
            valueKey="value"
            textKey="value"
            onSelect={handleConfiguration}
          />
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(RoutingConfiguration);
